import React from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import Button from 'design-system/Button';
import IconGift from 'design-system/icons/IconGift';
import { ButtonGroup, rem, RequestActionView, Spacer } from 'design-system';
const strings = {
    title: 'Claim your reward!',
    titleCashback: 'Claim your cashback!',
    buttonText: 'Let’s claim the cash!',
    subTitle1: 'Your cash is ready to be claimed! We are going to send this to your PayPal account',
    subTitle2: 'In the next step, we will ask you to confirm your email address associated with your PayPal, so we can send you the reward!',
    subTitle2Cashback: 'In the next step, we will ask you to confirm your email address associated with your PayPal, so we can send you the cashback!',
};
const ClaimRewardsDetailsScreen = ({ route, navigation, }) => {
    const onPressClaim = () => {
        const { params = {} } = route;
        navigation.navigateDeprecated('ClaimEmail', {
            ...params,
            keyBack: route.key,
        });
    };
    return (<RequestActionView renderIcon={() => (<>
          <IconGift colorKey="brand" height={84} width={84}/>
          <Spacer h={16}/>
        </>)} renderTitle={() => (<Text Text-24 centered>
          {route.params?.isClaimingReferral
                ? strings.title
                : strings.titleCashback}
        </Text>)} renderSubTitle={() => (<View>
          <Text TextThin-16 Secondary style={styles.subTitle}>
            {strings.subTitle1}
          </Text>
          <Text TextThin-16 Secondary style={styles.subTitle}>
            {route.params?.isClaimingReferral
                ? strings.subTitle2
                : strings.subTitle2Cashback}
          </Text>
        </View>)}>
      <ButtonGroup type="floating">
        <Button brand onPress={onPressClaim} title={strings.buttonText}/>
      </ButtonGroup>
    </RequestActionView>);
};
const styles = StyleSheet.create({
    subTitle: {
        textAlign: 'center',
        paddingBottom: rem(8),
    },
});
export default ClaimRewardsDetailsScreen;
